import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';
import {property} from 'lit/decorators/property.js';
import {AttributeType, ConfigurationInterpreter, DecisionKind} from '@viamedici-spc/configurator-ts';

import {SpcBaseAttribute} from './spcBaseAttribute';


@customElement('spc-assistant-choice-attribute')
export class SpcAssistantChoiceAttribute extends SpcBaseAttribute {

	@property({type: Object})
	title = null;

	static styles = [
		css`
			:host {
				width: var(--assistant-widget-width);
			}
			.title {
				display: flex;
				align-items: center;
				font: var(--font-widget-big-title);
				color: var(--color-widget-text);
				line-height: 1.4;
				margin-bottom: 40px;
			}
			.values {
				display: flex;
				flex-direction: column;
				border: none;
				gap: 8px
			}
			.attribute {
				break-inside: avoid;
			}
		`];

	stateChanged(state) {
		super.stateChanged(state);

		if (this.spcConfiguration) {
			this.attribute = ConfigurationInterpreter.getChoiceAttribute(this.spcConfiguration, this.attributeId);
			if (this.attribute) {
				this.values = Array.from(this.attribute.values.values());
				// this.allowedChoiceValues = AttributeInterpreter.getAllowedChoiceValues(this.attribute);
				// this.blockedChoiceValues = AttributeInterpreter.getBlockedChoiceValues(this.attribute);
				// this.selectedChoiceValueIds = AttributeInterpreter.getIncludedChoiceValues(this.attribute).map((a) => a.id);
				// console.log('attribute ' + this.attributeId.localId, {attribute: this.attribute, values: this.values});
			} else {
				console.error('Choice attribute not found with id', this.attributeId, this.spcConfiguration);
			}
		}
	}

	async resetDecision() {
		const resetDecisions = [...this.attribute.values.values()]
			.filter(v => v.decision !== null && v.decision.kind === DecisionKind.Explicit)
			.map(v => ({
				type: AttributeType.Choice,
				attributeId: this.attribute.id,
				choiceValueId: v.id,
				state: null,
			}));
		if (resetDecisions.length > 0) {
			await this.session.makeManyDecisions(resetDecisions, {type: 'KeepExistingDecisions'});
		}
	}

	isSatisfied() {
		return this.attribute?.isSatisfied ?? false;
	}

	render() {
		if (!this.values) return null;
		return html`
			<div class="attribute ${classMap({satisfied: this.isSatisfied()})}">
				<div class="title">
					${when(this.title !== null, () => html`
						<span>${this.title[this.lang]}</span>
					`, () => html`
						<trans-label
							key="${this.attributeId.localId}"
							context="F"
							title="${this.attributeId.localId}">
						</trans-label>
					`)}
				</div>
				<div class="values">
					${repeat(this.values
							.sort((a, b) => this.getProductDataForValue(a.id)?.displaySequenceUi - this.getProductDataForValue(b.id)?.displaySequenceUi),
						(value) => value.id,
						(value) => html`
							<spc-assistant-choice-value
								.attributeId=${this.attributeId}
								.value=${value}
								.hideDisabled=${this.hideDisabled}
								.productData=${this.getProductDataForValue(value.id)}>
							</spc-assistant-choice-value>`
					)}
				</div>
			</div>
		`;
	}
}
